import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumber from 'libphonenumber-js'

import { InfoBulle } from '../ImportAll'
import './Bloc.css'

class BlocPhoneNumber extends Component {
    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'
        style.minHeight = '122px'

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        let erreur = <div></div>
        if (this.props.validated === false) {
            if (this.props.messageErreur) {
                erreur = (
                    <div className="erreurTextFormat">
                        {this.props.messageErreur}
                    </div>
                )
            }
        }

        let premadeContent = (
            <div>
                <div className="labelfield">{this.props.label}</div>
                <div className="container-tel-form">
                    <PhoneInput
                        country={'fr'}
                        value={this.props.targetDataValue}
                        enableSearch={true}
                        placeholder={this.props.placeholder}
                        countryCodeEditable={false}
                        enableTerritories={true}
                        /*
                            Historique : ancienne liste blanche d'indicatifs autorisés.
                            Désormais tous les indicatifs sont autorisés (prop onlyCountries retirée).
                            onlyCountries={[
                                'fr', // FRANCE METROPOLITAINE
                                'gp', // GUADELOUPE -
                                'mq', // MARTINIQUE -
                                're', // REUNION -
                                'mf', // ST MARTIN FR -
                                'gf', // GUYANE -
                                'yt', // MAYOTTE --> non fonctionnel mayotte utilise le même indicatif que la réunion.
                                'nc', // NOUVELLE CALÉDONIE -
                                'pf', // POLYNÉSIE FRANÇAISE -
                                'pm', // ST PIERRE ET MIQUELON -
                                'wf', // WALLIS & FUTUNA -
                                'bl', // saint bathélemy -
                                'be', // BELGIQUE
                                'de', // ALLEMAGNE
                                'it', // ITALIE
                                'es', // ESPAGNE
                                'lu', // LUXEMBOURG
                                'ch', // SUISSE
                                'nl', // PAYS-BAS
                                'ro', // ROUMANIE
                                'pl', // POLOGNE
                                'pt', // PORTUGAL
                                'ie', // IRLANDE
                                'gb', // ROYAUME-UNI
                                'ca', // CANADA
                                'us', // ÉTATS-UNIS
                                'dz', // ALGÉRIE
                                'ma', // MAROC
                                'tn', // TUNISIE
                                'il', // ISRAËL
                                'au', // AUSTRALIE
                                'br', // BRÉSIL
                                'ae', // ÉMIRATS ARABES UNIS
                                'th', // THAÏLANDE
                                'mg', // MADAGASCAR
                                'tr', // TURQUIE
                                'mx', // MEXIQUE
                                'nz', // NOUVELLE-ZÉLANDE
                                'zw', // ZIMBABWE
                                'jp', // JAPON
                                'se', // SUÈDE
                                'ar', // ARGENTINE
                                'cz', // RÉPUBLIQUE TCHÈQUE
                                'dk', // DANEMARK
                                'sn', // SÉNÉGAL
                                'in', // INDE
                                'gr', // GRÈCE
                                'cn', // CHINE
                                'no', // NORVÈGE
                                'cl', // CHILI
                                'ci', // CÔTE D IVOIRE
                                'kr', // CORÉE DU SUD
                                'lb', // LIBAN
                                'vn', // VIÊT NAM
                                'co', // COLOMBIE
                                'mu', // MAURICE
                                'at', // AUTRICHE
                                'tw', // TAÏWAN
                                'za', // AFRIQUE DU SUD
                                'sg', // SINGAPOUR
                                'hk', // HONG KONG
                                'hu', // HONGRIE
                                'ph', // PHILIPPINES
                                'qa', // QATAR
                                'tg', // TOGO
                                'sa', // ARABIE SAOUDITE
                                'pe', // PÉROU
                                'cm', // CAMEROUN
                                'li', // LIECHTENSTEIN
                                'ad', // ANDORRE
                                'mc', // MONACO
                                'bg', // BULGARIE
                                'cy', // CHYPRE
                                'hr', // CROATIE
                                'ee', // ESTONIE
                                'fi', // FINLANDE
                                'lv', // LETTONIE
                                'lt', // LITUANIE
                                'mt', // MALTE
                                'sk', // SLOVAQUIE
                                'si', // SLOVÉNIE
                            ]}
                        */
                        onChange={(phone) =>
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: this.props.linked_data_id,
                                    value: '+' + phone,
                                },
                            })
                        }
                        isValid={(value, country) => {
                            let valid = false
                            const phoneNumber = parsePhoneNumber(
                                value,
                                country.iso2.toUpperCase()
                            )

                            if (phoneNumber) {
                                valid = phoneNumber.isValid()
                            }
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key:
                                        this.props.linked_data_id +
                                        '_validated',
                                    value: valid,
                                },
                            })
                            return valid
                        }}
                    />
                </div>
                {erreur}
            </div>
        )

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
        validated: state.answer[ownProps.linked_data_id + '_validated'],
    }
}

export default connect(mapStateToProps)(BlocPhoneNumber)
